import * as types from '../constants/mindMap';

const initialState = {
    id: '',
    cclKeywordsMindmap: [],
    found: 0,
    showing: 0,
    authorized: false,
    loading: false,
    error: false
};

const mindMap = (state = initialState, {
    type,
    ...action
}) => {
    switch (type) {
        case types.GET_CCL_KEYWORDS:
            return {
                ...state,
                loading: true,
                error: false,
                id: action.id
            };

        case types.SET_CCL_KEYWORDS:
           return {
                ...state,
                id: action.id,
                cclKeywordsMindmap: action.cclKeywordsMindmap,
                found: action.found,
                showing: action.showing,
                authorized: action.authorized,
                loading: false,
                error: false
            };

        case types.ERROR_CCL_KEYWORDS:
            return {
                ...state,
                id: '',
                cclKeywordsMindmap: [],
                found: 0,
                showing: 0,
                loading: false,
                error: true,
                authorized: false
            };

        default: return state;
    }
};

export default mindMap;